let FundamentalTabFilterType  = {
  All: 1,
  Dollars: 2,
  Commonsize: 3,
  Yearoveryear: 4
}
export default FundamentalTabFilterType;